import { useState } from "react"
import { aboutUsCards } from "../../data/data"

export default function AboutUsCards() {
  const [cards] = useState(aboutUsCards)

  return (
    <>
      <section className="bg-blue py-10 lg:py-20">
        <h2 className="text-white text-center text-3xl lg:text-5xl mb-5 lg:mb-16 px-5 2xl:px-0">
          Our fundamental values
        </h2>
        <div className="px-5 xl:max-w-6xl xl:mx-auto 2xl:px-0 text-center sm:grid grid-cols-2 gap-10 lg:grid-cols-3">
          {cards.map(({ id, title, image, desc }) => (
            <article key={id} className="lg:w-72">
              <img
                src={image}
                alt={title}
                title={title}
                className="block mx-auto w-16 lg:w-20"
              />
              <h4 className="text-white text-xl uppercase mt-5 mb-3 lg:text-3xl">
                {title}
              </h4>
              <p className="light text-white mb-10">{desc}</p>
            </article>
          ))}
        </div>
      </section>
    </>
  )
}
